import axios from 'axios';

const apiSearchVolumes = {
    post(params, idToken) {
        const headers = {
            Authorization: 'Bearer ' + idToken,
            'X-From': location.href
        };
        return axios.post(
            `${process.env.VUE_APP_APIURL}/search-volumes`,
            params,
            {
                headers: headers
            }
        );
    }
};
export default apiSearchVolumes;
